import { backendApi } from "../api";

// Define the new endpoints
const photoEndpoints = backendApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadPhoto: builder.mutation({
      query: ({
        file,
        metaData,
      }: {
        file: File;
        metaData: { homeId: string };
      }) => {
        const formData = new FormData();
        console.log("file", file);
        formData.append("photo", file);
        return {
          url: `/home/${metaData.homeId}/photo/upload`,
          method: "POST",
          data: formData,
        };
      },
      invalidatesTags: (result, error, { metaData }) => [
        { type: "Homes", id: String(metaData.homeId) }, // Invalidate the specific home
        { type: "Homes", id: "LIST" }, // Invalidate list queries, if applicable
      ],
    }),
    deletePhoto: builder.mutation({
      query: ({ homeId, photoId }: { homeId: string; photoId: string }) => {
        return {
          url: `/home/${homeId}/photo/${photoId}`,
          method: "DELETE",
        };
      },
      invalidatesTags: (result, error, { homeId }) => [
        { type: "Homes", id: String(homeId) }, // Invalidate the specific home
        { type: "Homes", id: "LIST" }, // Invalidate list queries, if applicable
      ],
    }),
    makeMainPhoto: builder.mutation({
      query: ({ homeId, fileName }: { homeId: string; fileName: string }) => {
        return {
          url: `/home/${homeId}/photo/${fileName}/main`,
          method: "PATCH",
        };
      },
      invalidatesTags: (result, error, { homeId }) => [
        { type: "Homes", id: String(homeId) }, // Invalidate the specific home
        { type: "Homes", id: "LIST" }, // Invalidate list queries, if applicable
      ],
    }),
  }),
});

// Export the hooks for the new endpoints
export const {
  useUploadPhotoMutation,
  useDeletePhotoMutation,
  useMakeMainPhotoMutation,
} = photoEndpoints;
